import React from "react";
import HierarchicPieChart from "../../../../components/charts/HierarchicPieChart/HierarchicPieChart";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { styles } from "./StatsViews.styles";
import { StatsTable } from "../StatsTable";
import { useSelector } from "react-redux";
import { IStatsFilters } from "../StatsFilter/StatsFilter";
import { IColumnMapping } from "../../../../components/CsvExport/CsvExportButton";
import { convertNumberToDateString } from "../../../../../utilities/dateTimeUtils";
import { IUniversalTableColumn } from "../../../../components/UniversalTable/interfaces";

const dataColumns: IUniversalTableColumn[] = [
    {
        type: "text",
        title: "Product Category",
        field: "productCategory"
    },
    {
        type: "text",
        title: "Subscription Name",
        field: "subscriptionName"
    },
    {
        type: "text",
        title: "Email",
        field: "email"
    },
    {
        type: "text",
        title: "Company",
        field: "company"
    },
    {
        type: "text",
        title: "SAP BP-ID",
        field: "bpId"
    },
    {
        type: "text",
        title: "SAP BP-Name",
        field: "bpName"
    },
    {
        type: "text",
        title: "Range Type",
        field: "rangeType"
    },
    {
        type: "date",
        title: "Start Date",
        field: "startDate"
    },
    {
        type: "date",
        title: "End Date",
        field: "endDate"
    },
    {
        type: "boolean",
        title: "Trial",
        field: "trial"
    },
    {
        type: "boolean",
        title: "Sales trial",
        field: "salesTrial"
    }
];

const dataExportMapping: IColumnMapping[] = [
    {
        key: "productCategory",
        label: "Product Category"
    },
    {
        key: "subscriptionName",
        label: "Subscription Name"
    },
    {
        key: "email",
        label: "Email"
    },
    {
        key: "additionalEmail2",
        label: "Email 2"
    },
    {
        key: "additionalEmail3",
        label: "Email 3"
    },
    {
        key: "userFirstName",
        label: "First Name"
    },
    {
        key: "userLastName",
        label: "Last Name"
    },
    {
        key: "company",
        label: "Company"
    },
    {
        key: "bpId",
        label: "SAP BP-ID"
    },
    {
        key: "bpName",
        label: "SAP BP-Name"
    },
    {
        key: "rangeType",
        label: "Range Type"
    },
    {
        key: "startDate",
        label: "Start Date",
        mappingFunc: value => convertNumberToDateString(value)
    },
    {
        key: "endDate",
        label: "End Date",
        mappingFunc: value => convertNumberToDateString(value)
    },
    {
        key: "trial",
        label: "Trial",
        mappingFunc: value => (value ? "Yes" : "No")
    },
    {
        key: "salesTrial",
        label: "Sales Trial",
        mappingFunc: value => (value ? "Yes" : "No")
    }
];

const summaryColumns = [
    {
        type: "text",
        title: "Subscription Name",
        field: "subscriptionName"
    },
    {
        type: "text",
        title: "User Number",
        field: "userNumber"
    }
];

const summaryDataExportMapping: IColumnMapping[] = [
    {
        key: "subscriptionName",
        label: "Subscription Name"
    },
    {
        key: "userNumber",
        label: "User Number"
    }
];

export interface ISubscribersViewProps extends WithStyles<typeof styles> {
    from?: number;
    to?: number;
    filters?: IStatsFilters;
}

const SubscribersViewPure: React.FunctionComponent<ISubscribersViewProps> = ({
    from,
    to,
    filters,
    classes
}: ISubscribersViewProps) => {
    const subscribers = useSelector(state => state.statistics.subscribers);
    return (
        <>
            <HierarchicPieChart
                data={subscribers?.data as Array<any>}
                levels={["productCategory", "subscriptionName", "email", "rangeType"]}
                aggregationOptions="count"
                title="Subscribers"
                secondaryTitle={`Total subscribers: ${subscribers?.summary.totalSubscriptions}`}
                showBreadcrumbs={true}
                noLegend={true}
            />
            <StatsTable
                dataColumns={dataColumns}
                summaryColumns={summaryColumns}
                data={subscribers?.data}
                summaryData={subscribers?.summary.summaryData}
                exportFilePrefix="subscribers"
                dataExportMapping={dataExportMapping}
                summaryDataExportMapping={summaryDataExportMapping}
            />
        </>
    );
};

export const SubscribersView = withStyles(styles)(SubscribersViewPure);
